import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import React from "react";
import { Card } from "react-bootstrap";

import { PropertTypes, RIHousePropertTypes } from "../../../../config/filingConstants";
import { ISelfOccupiedProperties } from "../../../../config/interfaces";
import { useAppDispatch } from "../../../../redux/Store";
import { showHintModal } from "../../../../redux/slice/HintModalSlice";
import FASvgIcon from "../../../FASvgIcon";
import { FormField, SelectInputField } from "../../../fields";

type Props = {
  initialValues: ISelfOccupiedProperties;
  isDisabled: boolean;
};

const RISelfPropertyTypeForm: React.FC<Props> = (props: Props) => {
  const { initialValues, isDisabled = false } = props;

  const { values, errors, touched, setFieldValue, setValues, handleBlur } =
    useFormikContext<ISelfOccupiedProperties>();

  const dispatch = useAppDispatch();

  return (
    <>
      <section className="mb-5">
        <FormField
          label={
            <>
              Your property type
              <span
                className="info-wrap"
                role="button"
                onClick={() => {
                  dispatch(
                    showHintModal({
                      title: "Your Property Type",
                      componentName: "PropertyTypeHint"
                    })
                  );
                }}
              >
                <FASvgIcon icon={faInfoCircle} />
              </span>
            </>
          }
          isRequired={true}
          sm={3}
        >
          <SelectInputField
            placeholder="Select property type"
            name="PropertyType"
            isOptionArrayOfObject={false}
            options={RIHousePropertTypes}
            value={[values.PropertyType]}
            onChange={(_selectedPropertyType) => {
              if (_selectedPropertyType) {
                setValues({ ...initialValues });
                setFieldValue("PropertyType", _selectedPropertyType.value);
              } else {
                setFieldValue("PropertyType", undefined);
              }
            }}
            onBlur={handleBlur("PropertyType")}
            isInvalid={Boolean(errors.PropertyType) && touched.PropertyType}
            errorMsg={errors.PropertyType}
            isDisabled={isDisabled}
          />
        </FormField>

        {values.PropertyType === PropertTypes.DEEMED ? (
          <Card className="more-info-card shadow-none" bg="greyDefault">
            <Card.Body>
              <h5>Why is my property type selected as a Deemed Let Out?</h5>
              <p className="primary-para text-greyDark mb-0">
                As per Income Tax Provisions, you can declare maximum 2 properties as "Self
                Occupied". As you have already added 2 self occupied house properties, the 3rd or
                subsequent properties which are not given on rent will be considered as "Deemed Let
                out". For Deemed Let out properties, you will have to enter the estimated rent that
                the property can yield.
              </p>
            </Card.Body>
          </Card>
        ) : null}
      </section>
    </>
  );
};

export default RISelfPropertyTypeForm;
